<template>
  <div class="app-loading" v-if="isLoading">
    <div class="hollow-dots-spinner">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div>
        <div class="load">Processing...</div>
        <div class="message">Please do not close/refresh this window or click the Back button on your browser.</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

// Vuex store
const store = useStore();

// Computed property 
const isLoading = computed(() => store.state.isLoading);
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/loading";
     .load {
      color:white;
      width: 100%;
      height: 100%;
      font-size: 25px;
      font-weight:bold ;
    }
    .message {
      color:white;
      width: 150%;
      height: 100%;
      font-size: 15px;
    }
</style>